import * as React from 'react';
import { Tag } from '../tag/Tag';
import { formatNumber } from '@mc/react-format';

type Props = {
  totalDataElements?: number;
};

export const RowsCount = ({ totalDataElements }: Props) => {
  let text;
  if (totalDataElements !== undefined) {
    if (totalDataElements >= 5) {
      text = `${formatNumber(totalDataElements)} záznamů`;
    } else if (totalDataElements > 1) {
      text = `${formatNumber(totalDataElements)} záznamy`;
    } else if (totalDataElements === 1) {
      text = `${formatNumber(totalDataElements)} záznam`;
    } else {
      text = '0 záznamů';
    }
  } else {
    text = 'načítání záznamů';
  }

  return (
    <Tag intent={'secondary'} inverse>
      {text}
    </Tag>
  );
};
